import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';
import {Connection} from '../message/Connection';
import {ConnectionCriteriaExt} from './ConnectionCriteriaExt';

export class ConnectionWrapperExt extends BaseWrapper<Connection, ConnectionCriteriaExt, BasicScenario>  {}

